import MonthView from 'react-big-calendar/lib/Month'
import dates from 'react-big-calendar/lib/utils/dates'
import localizer from 'react-big-calendar/lib/localizer'
import chunk from 'lodash/chunk'
import DateContentRow from 'react-big-calendar/lib/DateContentRow'
import DateHeader from 'react-big-calendar/lib/DateHeader'
import { inRange, sortEvents } from 'react-big-calendar/lib/utils/eventLevels'

let eventsForWeek = (evts, start, end, props) => evts.filter((e) => inRange(e, start, end, props))

class CalendarMonth extends MonthView {
  constructor(props) {
    super(props)
    this.customReaderDateHeading = this.customReaderDateHeading.bind(this)
  }

  // A fast click/tap can resolve into a 'select' event before any week row ever
  // recorded a valid slot range (each row's Selection instance listens globally,
  // so a click with no intermediate mousemove leaves _pendingSelection empty).
  // The base implementation then reads .getDate() off the last (nonexistent)
  // slot and crashes - skip the notify when there's nothing valid to select.
  selectDates(slotInfo) {
    if (this._pendingSelection.length === 0) {
      return
    }
    super.selectDates(slotInfo)
  }

  customRenderWeek(week, weekIdx) {
    let {
      events,
      components,
      selectable,
      titleAccessor,
      tooltipAccessor,
      startAccessor,
      endAccessor,
      allDayAccessor,
      getNow,
      eventPropGetter,
      dayPropGetter,
      messages,
      selected,
      date,
      longPressThreshold,
    } = this.props

    let { needLimitMeasure, rowLimit } = this.state
    // override rowLimit for showing all events in day instead of showing + more
    if (this.props.maxRows) {
      rowLimit = this.props.maxRows
    }
    events = eventsForWeek(events, week[0], week[week.length - 1], this.props)
    events.sort((a, b) => sortEvents(a, b, this.props))

    return (
      <DateContentRow
        key={weekIdx}
        ref={weekIdx === 0 ? 'slotRow' : undefined}
        container={this.getContainer}
        className="rbc-month-row"
        getNow={getNow}
        date={date}
        range={week}
        events={events}
        maxRows={rowLimit}
        selected={selected}
        selectable={selectable}
        messages={messages}
        titleAccessor={titleAccessor}
        tooltipAccessor={tooltipAccessor}
        startAccessor={startAccessor}
        endAccessor={endAccessor}
        allDayAccessor={allDayAccessor}
        eventPropGetter={eventPropGetter}
        dayPropGetter={dayPropGetter}
        renderHeader={this.readerDateHeading}
        renderForMeasure={needLimitMeasure}
        onShowMore={() => {}} // replace with empty function to not firing library function
        onSelect={this.handleSelectEvent}
        onDoubleClick={this.handleDoubleClickEvent}
        onSelectSlot={this.handleSelectSlot}
        eventComponent={components.event}
        eventWrapperComponent={components.eventWrapper}
        dateCellWrapperComponent={components.dateCellWrapper}
        longPressThreshold={longPressThreshold}
      />
    )
  }

  customReaderDateHeading({ date, className, ...props }) {
    let { date: currentDate, getDrilldownView, dateFormat, culture } = this.props

    let isOffRange = dates.month(date) !== dates.month(currentDate)
    let isCurrent = dates.eq(date, currentDate, 'day')
    let drilldownView = getDrilldownView(date)
    let label = localizer.format(date, dateFormat, culture)
    let DateHeaderComponent = this.props.components.dateHeader || DateHeader

    return (
      <div
        {...props}
        className={[className, isOffRange && 'rbc-off-range', isCurrent && 'rbc-current']
          .filter(Boolean)
          .join(' ')}
      >
        <DateHeaderComponent
          label={label}
          date={date}
          drilldownView={drilldownView}
          isOffRange={isOffRange}
          onDrillDown={(e) => e.preventDefault()}
        />
      </div>
    )
  }

  render() {
    let { date, culture, weekdayFormat, className } = this.props
    let month = dates.visibleDays(date, culture)
    let weeks = chunk(month, 7)

    this._weekCount = weeks.length

    return (
      <div className={['rbc-month-view', className].filter(Boolean).join(' ')}>
        <div className="rbc-row rbc-month-header">
          {this.renderHeaders(weeks[0], weekdayFormat, culture)}
        </div>
        {weeks.map((week, idx) => this.customRenderWeek(week, idx))}
        {this.props.popup && this.renderOverlay()}
      </div>
    )
  }
}

export default CalendarMonth
